export default "__VITE_ASSET__B2D2Zv0N__"